import { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';  // Import SweetAlert2
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const Buyer = () => {
    const [buyers, setBuyers] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showStockModal, setShowStockModal] = useState(false);
    const [showBonusModal, setShowBonusModal] = useState(false);
    const [selectedBuyer, setSelectedBuyer] = useState(null);
    const [newStock, setNewStock] = useState({
        totalStock: 0,
        stockSold: 0,
        stockLeft: 0,
    });
    const [amount, setAmount] = useState(0);
    const [deviationBonus, setDeviationBonus] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // Track current page
    const [totalPages, setTotalPages] = useState(1); // Track total number of pages
    const [deletedBuyers, setDeletedBuyers] = useState(new Set()); // Track deleted suppliers

    useEffect(() => {
        checkAdminStatus();
    }, []);

    useEffect(() => {
        if (isAdmin) {
            fetchAllBuyers();
        }
    }, [currentPage, isAdmin]);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);
        if (!isAdmin) {
            console.error('Unauthorized: User is not an admin');
        }
    };

    const fetchAllBuyers = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }

            const response = await axios.get(`https://hbmdijital.online/api/admin/buyers?page=${currentPage}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                setBuyers(response.data.data); // Get buyers from paginated response
                setTotalPages(response.data.last_page); // Get total number of pages
            } else {
                console.error('Failed to fetch buyers:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching buyers:', error);
        }
    };
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber); // Update current page
    };

    const handleEditStockClick = (buyer) => {
        setSelectedBuyer(buyer);
        setNewStock({
            totalStock: buyer.total_stock,
            stockSold: buyer.stock_sold,
            stockLeft: buyer.stock_left,
        });
        setShowStockModal(true);
    };

    const handleSaveStockChanges = async () => {
        try {
            const token = localStorage.getItem('authToken');

            if (!selectedBuyer) {
                console.error("No buyer selected.");
                return;
            }

            const response = await axios.put(
                `https://hbmdijital.online/api/admin/sell-stock`,
                { 
                    buyer_id: selectedBuyer.id,
                    amount: parseFloat(amount)
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                setShowStockModal(false);
                fetchAllBuyers();

                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Stock mis jour avec succès !',
                    timer: 2000,
                    showConfirmButton: false,
                });
            } else {
                throw new Error('�chec de la mise � jour du stock');
            }
        } catch (error) {
            console.error('Error updating stock:', error.response?.data || error.message);

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: '�chec de la mise � jour du stock. Veuillez r�essayer�!',
            });
        }
    };

    const handleEditBonusClick = (buyer) => {
        setSelectedBuyer(buyer);
        setDeviationBonus(buyer.deviation_bonus);
        setShowBonusModal(true);
    };

    const handleSaveBonusChanges = async () => {
        try {
            const token = localStorage.getItem('authToken');

            if (!selectedBuyer) {
                console.error("No buyer selected.");
                return;
            }

            const response = await axios.put(
                `https://hbmdijital.online/api/admin/users/${selectedBuyer.id}/deviation-bonus`,
                { deviation_bonus: parseFloat(deviationBonus) },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                setShowBonusModal(false);
                fetchAllBuyers();

                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Deviation Bonus updated successfully!',
                    timer: 2000,
                    showConfirmButton: false,
                });
            } else {
                throw new Error('Failed to update deviation bonus');
            }
        } catch (error) {
            console.error('Error updating deviation bonus:', error.response?.data || error.message);

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to update Deviation Bonus. Please try again!',
            });
        }
    };
const banUser = async (buyerId) => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.delete(
                `https://hbmdijital.online/api/admin/user/${buyerId}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                // Update the deletedSuppliers state to include the deleted supplier ID
                setDeletedBuyers((prev) => new Set(prev.add(buyerId)));
                Swal.fire("Success", "Utilisateur supprim� avec succ�s!", "success");
                fetchAllBuyers(); // Refresh the supplier list
            } else {
                Swal.fire("Error", "�chec de la suppression", "error");
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data || "Something went wrong", "error");
            fetchAllBuyers(); // Refresh supplier list in case of error
        }
    };


    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex">
                <section className="w-100 p-3">
                    <hr className="my-4" />
                    <div className="table-responsive"> {/* Make table scrollable on small screens */}
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                            <tr>
    <th>ID Client</th>
    <th>Nom</th>
    <th>Email</th>
    <th>Téléphone</th>
    <th>Adresse</th>
    <th>Stock Total</th>
    <th>Stock Vendu</th>
    <th>Stock Restant</th>
    <th>Actions</th>
</tr>

                            </thead>
                            <tbody>
                                {buyers.map((buyer) => (
                                    <tr key={buyer.id}>
                                        <td>{buyer.custom_id}</td>
                                        <td>{buyer.name}</td>
                                        <td>{buyer.email}</td>
                                        <td>{buyer.phone}</td>
                                        <td>{buyer.address}</td>
                                        <td>{buyer.total_stock}</td>
                                        <td>{buyer.stock_sold}</td>
                                        <td>{buyer.stock_left}</td>
                                        {/* <td>{buyer.deviation_bonus}</td> */}
                                        <td>
                                            <button className="btn btn-warning me-2" onClick={() => handleEditStockClick(buyer)}>Modifier le stock</button>


                <button
                    className="btn btn-danger"
                    onClick={() => banUser(buyer.id)}
                    disabled={buyer.is_deleted} // Disable the button if the user is deleted
                >
                    Ban
                </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="pagination">
                        <button 
                            className="btn btn-secondary" 
                            onClick={() => handlePageChange(currentPage - 1)} 
                            disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span>Page {currentPage} of {totalPages}</span>
                        <button 
                            className="btn btn-secondary" 
                            onClick={() => handlePageChange(currentPage + 1)} 
                            disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </section>
            </div>

            {/* Edit Stock Modal */}
            <Modal show={showStockModal} onHide={() => setShowStockModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Modifier le stock pour {selectedBuyer?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <label>Entrez le montant vendu :</label>
                    <input type="number" className="form-control" value={amount} onChange={(e) => setAmount(e.target.value)} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowStockModal(false)}>Fermer</Button>
                    <Button variant="primary" onClick={handleSaveStockChanges}>Enregistrer les modifications</Button>
                </Modal.Footer>
            </Modal>

            {/* Edit Bonus Modal */}
         

            <Footer />
        </AnimationRevealPage>
    );
};

export default Buyer;
